import {
  isCallTask,
  isWhatsappTask,
} from '../../../../../tasks/components/tasks-content/utils/helper';
import { CallPurpose, SequenceStepType, StepType } from '../../../../enums';

export enum LinkedInTaskType {
  ConnectionRequest = 'Connection Request',
  Message = 'Message',
  InMail = 'InMail',
  ViewProfile = 'View Profile',
  PostInteraction = 'Post Interaction',
}

export enum PurposeOfCall {
  Introduction = 'Introduction',
  Demo = 'Demo',
  FollowUp = 'Follow-up',
  Reminder = 'Reminder',
  Other = 'Other',
}

export enum WhatsAppTaskType {
  Message = 'Message',
  VoiceMessage = 'Voice Message',
  VoiceCall = 'Voice Call',
}

export const WHATSAPP_MAX_LIMIT = 6000;

export const contentMaxLength = {
  [LinkedInTaskType.ConnectionRequest]: 300,
  [LinkedInTaskType.Message]: 8000,
  [LinkedInTaskType.InMail]: 1900,
  [LinkedInTaskType.ViewProfile]: 3000,
  [LinkedInTaskType.PostInteraction]: 3000,
  [StepType.Call]: 3000,
  [StepType.WhatsApp]: WHATSAPP_MAX_LIMIT,
  [StepType.Task]: 3000,
};

export const subjectInputMaxLength = (stepType) =>
  stepType === StepType.Task ? 100 : 200;

export const isSubTypeSectionVisible = (stepType: StepType) =>
  stepType === StepType.LinkedIn ||
  stepType === StepType.Call ||
  stepType === StepType.WhatsApp;

export const getStepSubType = (stepType: StepType) => {
  if (stepType === StepType.Call) {
    return PurposeOfCall;
  }

  if (stepType === StepType.WhatsApp) {
    return WhatsAppTaskType;
  }

  return LinkedInTaskType;
};

export const getCallPurposeValue = (value: number): string | undefined => {
  const keys = Object.keys(CallPurpose).filter(
    (key) => CallPurpose[key as keyof typeof CallPurpose] === value,
  );
  return keys.length > 0 ? keys[0] : undefined;
};

export const getCallPurposeId = (purpose): number => {
  if (CallPurpose[purpose]) {
    return Number(CallPurpose[purpose]);
  }

  return CallPurpose.FollowUp;
};

export const getCallPurposeTxt = (purposeId) => {
  const keys = Object.keys(CallPurpose).filter(
    (key) => (CallPurpose as any)[key] === purposeId,
  );

  if (keys[0] === 'FollowUp') {
    return 'Follow-up';
  }

  return keys.length > 0 ? keys[0] : undefined;
};

export const getInitialSubType = (initialSubType: SequenceStepType) => {
  if (initialSubType === SequenceStepType.LinkedInConnectionRequest) {
    return LinkedInTaskType.ConnectionRequest;
  }
  if (initialSubType === SequenceStepType.LinkedInMessage) {
    return LinkedInTaskType.Message;
  }
  if (initialSubType === SequenceStepType.LinkedInInMail) {
    return LinkedInTaskType.InMail;
  }
  if (initialSubType === SequenceStepType.LinkedInPostInteraction) {
    return LinkedInTaskType.PostInteraction;
  }
  if (initialSubType === SequenceStepType.LinkedInViewProfile) {
    return LinkedInTaskType.ViewProfile;
  }

  if (initialSubType === SequenceStepType.WhatsAppMessage) {
    return WhatsAppTaskType.Message;
  }

  if (initialSubType === SequenceStepType.WhatsAppVoiceMessage) {
    return WhatsAppTaskType.VoiceMessage;
  }

  if (initialSubType === SequenceStepType.WhatsAppVoiceCall) {
    return WhatsAppTaskType.VoiceCall;
  }

  return PurposeOfCall.Introduction;
};

export const getSubTypeSectionLabel = (stepType: StepType) => {
  if (stepType === StepType.Call) {
    return 'Purpose of the Call';
  }

  if (stepType === StepType.WhatsApp) {
    return 'Whatsapp Task Type';
  }

  return 'LinkedIn Task Type';
};

export const getStepContentSectionLabel = (type: SequenceStepType) => {
  if (type === SequenceStepType.LinkedInConnectionRequest) {
    return 'LinkedIn Connection Note';
  }
  if (type === SequenceStepType.LinkedInMessage) {
    return 'LinkedIn Message';
  }
  if (type === SequenceStepType.LinkedInInMail) {
    return 'InMail Message';
  }
  if (type === SequenceStepType.Call) {
    return 'Call Task Note';
  }

  if (type === SequenceStepType.WhatsAppMessage) {
    return 'WhatsApp Message';
  }

  if (type === SequenceStepType.WhatsAppVoiceCall) {
    return 'Voice Call Script';
  }

  if (type === SequenceStepType.WhatsAppVoiceMessage) {
    return 'WhatsApp Voice Message';
  }

  return 'Task Instruction';
};

export const getLinkedInType = (type: LinkedInTaskType) => {
  if (type === LinkedInTaskType.ConnectionRequest) {
    return SequenceStepType.LinkedInConnectionRequest;
  }
  if (type === LinkedInTaskType.Message) {
    return SequenceStepType.LinkedInMessage;
  }
  if (type === LinkedInTaskType.InMail) {
    return SequenceStepType.LinkedInInMail;
  }
  if (type === LinkedInTaskType.ViewProfile) {
    return SequenceStepType.LinkedInViewProfile;
  }

  return SequenceStepType.LinkedInPostInteraction;
};

export const getCallInType = (type: PurposeOfCall) => {
  if (type === PurposeOfCall.Introduction) {
    return SequenceStepType.Introduction;
  }
  if (type === PurposeOfCall.Demo) {
    return SequenceStepType.Demo;
  }
  if (type === PurposeOfCall.FollowUp) {
    return SequenceStepType.FollowUp;
  }
  if (type === PurposeOfCall.Reminder) {
    return SequenceStepType.Reminder;
  }

  return SequenceStepType.Other;
};

export const getWhatsappInType = (type: WhatsAppTaskType) => {
  if (type === WhatsAppTaskType.Message) {
    return SequenceStepType.WhatsAppMessage;
  }

  if (type === WhatsAppTaskType.VoiceMessage) {
    return SequenceStepType.WhatsAppVoiceMessage;
  }

  return SequenceStepType.WhatsAppVoiceCall;
};

export const getStepType = (type: SequenceStepType) => {
  if (
    type === SequenceStepType.LinkedInConnectionRequest ||
    type === SequenceStepType.LinkedInMessage ||
    type === SequenceStepType.LinkedInInMail ||
    type === SequenceStepType.LinkedInViewProfile ||
    type === SequenceStepType.LinkedInPostInteraction
  ) {
    return StepType.LinkedIn;
  }
  if (isWhatsappTask(type)) {
    return StepType.WhatsApp;
  }
  if (isCallTask(type)) {
    return StepType.Call;
  }
  if (type === SequenceStepType.Custom) {
    return StepType.Task;
  }

  return StepType.Email;
};

export const getDaysAndStepsObj = (steps) => {
  let absoluteExecutionDay = 1;
  const resultObject = {};

  for (const item of steps) {
    absoluteExecutionDay += item.relativeDays;
    resultObject[absoluteExecutionDay] = item.number;
  }

  return resultObject;
};

export const getSequenceTypeTooltipText = (type: SequenceStepType) => {
  if (type === SequenceStepType.LinkedInConnectionRequest) {
    return 'Personalized message to send with LinkedIn connection request for introduction and networking.';
  }
  if (type === SequenceStepType.LinkedInMessage) {
    return 'Personalized message you can send to the people in your network.';
  }
  if (type === SequenceStepType.LinkedInInMail) {
    return 'Write personalized InMail message';
  }

  if (type === SequenceStepType.Call) {
    return 'Add instructions/tips for task assignee to execute this task successfully.';
  }
  if (type === SequenceStepType.WhatsAppMessage) {
    return 'Personalized message you can send to people in your contacts.';
  }

  if (type === SequenceStepType.WhatsAppVoiceMessage) {
    return 'Provide a personalized message for the task assignee to record and send to the prospect as a voice message.';
  }

  if (type === SequenceStepType.WhatsAppVoiceCall) {
    return 'Add the script or key points for the voice call with the prospects.';
  }

  return 'Add instructions/tips for task assignee to execute this task successfully.';
};

export const isFormValid = (errors) =>
  !Object.keys(errors).some((k) => errors[k]);

export const isSubmitDisabled = (type, values) => {
  if (type === SequenceStepType.LinkedInMessage) {
    return values?.content.length < 2;
  }
  if (type === SequenceStepType.LinkedInInMail) {
    return values?.content.length < 2 || values?.subject?.length < 2;
  }

  return false;
};

export const getErrorString = (isError, value, maxLength, minLength = 2) => {
  if (!isError) {
    return '';
  }

  if (value?.trim()?.length === 0) {
    return 'Please enter a valid input. Blank spaces are not allowed.';
  }

  if (value.length < minLength) {
    return `Mandatory Field: At least ${minLength} characters needed`;
  }

  return `Character limit exceeds ${maxLength}`;
};

export const getStepInitialTaskNote = (steps, actionStep) => {
  const currentStep = steps.filter((step) => step.id === actionStep?.id);

  if (currentStep?.length) {
    const [{ variants }] = currentStep;
    const [{ taskNote }] = variants;

    return taskNote;
  }

  return '';
};

export const getIsAnyFieldDirty = (obj) =>
  Object.values(obj).some((value) => value === true);

export const getConfirmationModalContent = () => [
  {
    id: 1,
    text: 'confirmation_modal_content_2',
  },
];

export const getMinLength = (stepType, selectedStepType) => {
  if (
    selectedStepType === SequenceStepType.LinkedInConnectionRequest ||
    stepType === StepType.Task ||
    stepType === StepType.Call ||
    stepType === StepType.WhatsApp
  ) {
    return 0;
  }

  return 2;
};

export const getPlaceHolderText = (selectedStepSubType, stepType) => {
  if (
    (selectedStepSubType === LinkedInTaskType.Message ||
      selectedStepSubType === LinkedInTaskType.InMail) &&
    stepType === StepType.LinkedIn
  ) {
    return 'Add a concise purpose to your connection.';
  }
  if (
    (selectedStepSubType === LinkedInTaskType.ViewProfile ||
      selectedStepSubType === LinkedInTaskType.PostInteraction) &&
    stepType === StepType.LinkedIn
  ) {
    return 'Give details to a person who will perform this task, so as not to forget anything.';
  }

  if (stepType === StepType.Call || stepType === StepType.Task) {
    return 'Give details to a person who will perform this task, so as not to forget anything.';
  }

  if (selectedStepSubType === WhatsAppTaskType.Message) {
    return 'Enter the message you want to send to prospects.';
  }

  if (selectedStepSubType === WhatsAppTaskType.VoiceMessage) {
    return 'Write a short script to be recorded and sent as a voice message to your prospects.';
  }

  if (selectedStepSubType === WhatsAppTaskType.VoiceCall) {
    return 'Add a call script or key points to guide your conversation.';
  }

  return 'Briefly explain your reason for connecting.';
};

export const getIsExpandOptionVisible = (stepType, selectedStepSubType) => {
  if (
    stepType === StepType.Task ||
    selectedStepSubType === LinkedInTaskType.InMail
  ) {
    return true;
  }

  return false;
};

export const getContentAreaSize = (stepType, selectedStepSubType) => {
  if (selectedStepSubType === SequenceStepType.LinkedInInMail) {
    return 'sm';
  }
  if (
    stepType === StepType.Call ||
    selectedStepSubType === SequenceStepType.LinkedInPostInteraction ||
    selectedStepSubType === SequenceStepType.LinkedInViewProfile
  ) {
    return 'md';
  }
  if (stepType === StepType.Task) {
    return 'lg';
  }

  return 'xm';
};

export const getIsTaskNoteContent = (selectedStepType) => {
  if (
    selectedStepType === SequenceStepType.LinkedInPostInteraction ||
    selectedStepType === SequenceStepType.LinkedInViewProfile ||
    isCallTask(selectedStepType) ||
    selectedStepType === SequenceStepType.Custom
  ) {
    return true;
  }

  return false;
};

export const getTaskNoteModalTitle = (selectedStepType) => {
  if (selectedStepType === SequenceStepType.LinkedInInMail) {
    return 'InMail Message';
  }

  return 'Task Instruction';
};

export const getTaskNoteModalMaxLength = (selectedStepType) => {
  if (selectedStepType === SequenceStepType.LinkedInInMail) {
    return 1900;
  }

  return 3000;
};

export const getEditorHeight = (stepType, selectedStepType) => {
  // LinkedIn step types
  if (stepType === StepType.LinkedIn) {
    if (
      selectedStepType === SequenceStepType.LinkedInConnectionRequest ||
      selectedStepType === SequenceStepType.LinkedInMessage
    ) {
      return '244px';
    }
    if (
      selectedStepType === SequenceStepType.LinkedInViewProfile ||
      selectedStepType === SequenceStepType.LinkedInPostInteraction
    ) {
      return '286px';
    }
    if (selectedStepType === SequenceStepType.LinkedInInMail) {
      return '150px';
    }
  }

  // Call step type
  if (stepType === StepType.Call) {
    return '286px';
  }

  // Task step type
  if (stepType === StepType.Task) {
    return '278px';
  }

  // WhatsApp step types
  if (stepType === StepType.WhatsApp) {
    if (selectedStepType === SequenceStepType.WhatsAppMessage) {
      return '256px';
    }
    if (
      selectedStepType === SequenceStepType.WhatsAppVoiceMessage ||
      selectedStepType === SequenceStepType.WhatsAppVoiceCall
    ) {
      return '244px';
    }
  }

  // Default height
  return '16rem';
};
